



































import { Vue, Component } from 'vue-property-decorator';
import {
  Module, VuexModule, getModule, Mutation, Action,
} from '@compassdigital/vuex-module-decorators';
import { UserApi, User, UserAccess } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserInformation from '@/components/Form/UserInformation/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import Format from '@/util/Format';
import SystemModule from '@/store/modules/system';
import MarketUtil from '@/util/MarketUtil';

@Component({
  components: {
    UserInformation,
    TextButton,
    PrimaryButton,
  },
})
export default class CreateUserInformation extends Vue {
  private error: string = '';

  private loading: boolean = false;

  private lazy = false;

  private userInfo: any = {
    name: {
      first: '',
      last: '',
    },
    email: '',
    contactNumber: {
      phone: '',
    },
    selectedRole: '',
    is: {
      disabled: false,
      approver: false,
    },
    permission: {
      acl: {},
      scopes: [],
    },
    error: '',
    marketTypes: [],
  }

  public mounted() {
    this.getItems();
  }

  public async createNewUser() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.loading = true;
        if (AppModule.isLoggedIn && AppModule.accessToken) {
          if (this.userInfo.contactNumber.phone) {
            const { phone } = this.userInfo.contactNumber;
            this.userInfo.contactNumber.phone = Format.CheckMaskNumber(phone);
          }

          if (this.userInfo.selectedRole) {
            const scopesArray = [];
            scopesArray[0] = this.userInfo.selectedRole;
            this.userInfo.permission.scopes = scopesArray;
          }

          if (this.accessLimitUser) {
            this.userInfo.is.approver = false;
          }

          const marketApiAccess: UserAccess = ({
            marketId: this.userInfo.marketTypes,
          });

          const userData: any = ({
            name: this.userInfo.name,
            email: this.userInfo.email,
            phone: this.userInfo.contactNumber,
            is: this.userInfo.is,
            permissions: this.userInfo.permission,
          });

          try {
            const api = new UserApi(AppModule.apiConfig);
            const user = await api.createUser(userData);
            const userID:any = user.data.id;
            if (this.userInfo.selectedRole === 'fw_manager') {
              const marketFetched = await api.patchUserAccessById(userID, marketApiAccess);
            }
            const { data } = user;
            let message = 'User added';
            if (data) {
              const { name } = data;
              const { first, last } = name!;
              message = `${first} ${last} added`;
            }
            this.$router.push({ name: 'users', params: { message } });
          } catch (err) {
            throw err;
          }
        }
      } catch (err) {
        if (err.response.data) {
          const { data } = err.response;
          this.userInfo.error = data.error.message;
        }
      }
      this.loading = false;
    }
  }

  public async cancelUser() {
    this.$router.push('/users');
  }

  public async getItems() {
    const { markets }: any = SystemModule;
    const items = MarketUtil.getMappedMarketsValue(markets);
    const newMarkets = Format.sortedArray(items);
    const updatedArray: any = [];
    newMarkets.map(v => updatedArray.push(v.value));
    this.userInfo.marketTypes = updatedArray;
  }

  public get accessLimitUser() {
    if (this.userInfo.selectedRole === 'partner_owner'
    || this.userInfo.selectedRole === 'unit_manager'
    ) {
      return true;
    }
    return false;
  }
}
